<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :submit="submit"
    :status="status"
    :canCancel="false"
    :canUpdateDelete="false"
    next-link="/admin/coupons"
    :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '#'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: 'Editar',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters justify="center">
            <v-col class="d-flex justify-center">
              <ValidationProvider
                ref="commission_percentage"
                rules="percentage_valid|required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Actualizar Precio Spot por Hora</div>
                <v-select :error-messages="errors" v-model="data.parking_types" label="Tipo Parking" :items="spot_types" solo
                          hide-details="auto" class="input-base" append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.spot_price_hour" label="Spot Precio Hora" solo
                              hide-details="auto" class="input-base">
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Prices",
      title: "Precio Spot",
      data: {
        parking_types:"",
        spot_price_hour: "",
        commission_percentage: null,
        id: this.$route.params.id,
      },
      spot_types: [
        "casas",
        "parkings"
      ],
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Tags.status,
    }),
  },
  watch: {},
  methods: {
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function() {
            Swal(
              "Precio Spot Actualizado",
              "exitosamente",
              "success",
              {
                buttons: false,
                timer: 3000,
              }
            );
          })
          .catch(function(response) {
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
